import instance from '@apis/instance';
import { ItemResponse, ItemsResponse, NutritionResponse } from '@models/item';

class ItemApi {
    static getItem(id: string): Promise<ItemResponse> {
        return instance.get(`/item/${id}`);
    }

    static getItems(shopId: string, categoryId: string): Promise<ItemsResponse> {
        return instance.get(`/shop/${shopId}/items`, { params: { categoryId } });
    }

    static getNutrition(itemId: string): Promise<NutritionResponse> {
        return instance.get(`/item/${itemId}/nutrition`);
    }

    static getShopItemFromItemId(shopId: string, originalId: string): Promise<ItemResponse> {
        return instance.get('/item', { params: { originalId, shopId } });
    }
}
export default ItemApi;
